'use strict';

import { responseSuccess, responseError, requestAuthenticate } from '@/repositories/ApiInterceptors';

const fetch_nomination = async (url, config) => {
  return fetch(url, await requestAuthenticate(config, true))
    .then(responseSuccess)
    .catch(responseError);
};

export {
  fetch_nomination,
};
